import { ENUMS } from 'services/consts';

import AdvanceSettings from '../AdvanceSettings';
import SalesChannelDetailsForm from '../Forms/SalesChannelDetailsForm';

const ZohoCredentials = () => (
	<>
		<SalesChannelDetailsForm showBaseUrl={false} showToken={false} />
		<AdvanceSettings fields={['statuses', 'ignoreNonCodOnPending']} enumName={ENUMS.DEFAULT_CREDENTIALS_STATUSES} />
	</>
);

const Zoho = () => <ZohoCredentials />;

export default Zoho;
